export interface SchemaOptions {
    /**
     * Parse the schema SDL with graphql-js `parse(s, { noLocation: true })` instead of graphql-tag's
     * `gql`. This avoids attaching (and then deleting) `loc` on every AST node and skips
     * graphql-tag's document cache, which significantly reduces the retained heap size.
     */
    parseWithoutLocation?: boolean;
    
    /**
     * After the executable schema is built, release the parsed schema document and the SDL text:
     * clear `astNode`/`extensionASTNodes` on schema elements and don't cache the document.
     * Pair with `parseWithoutLocation`; graphql-tag's `gql` keeps its own document cache.
     */
    dropAst?: boolean;
}

let schemaOptions: SchemaOptions = {};

/**
 * The parsed schema is cached on first use, so this must be set before the schema is first loaded.
 */
export function setSchemaOptions(options: SchemaOptions): void {
    schemaOptions = { ...options };
}

export function getSchemaOptions(): SchemaOptions {
    return schemaOptions;
}
